import React, { useState, useEffect, useRef, useMemo } from "react";
// import ActiveLastBreadcrumb from "./breadcrumb.component";
import axios from "axios";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Dropdown from "../../share/components/dropdown";
import { Grid, Button, IconButton, Typography } from "@mui/material";
import ToolTip from "../../share/components/tooltip";
import PopOver from "../../share/components/popover.component";
import CloseIcon from "@mui/icons-material/Close";
import "../../css/backlink-checker.scss";
import { Link } from "react-router-dom";
import CustomButtonStyle from "../../share/components/button.component";
import logo from "../../Assets/seoimg/logo.png";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CircularProgress from "@mui/material/CircularProgress";
import backlinkImg from "../../Assets/backlink/backlink-tool.png";
import { ReCaptcha } from "../../share/components/googleRecaptacha";
import { useNavigate, useLocation } from "react-router-dom";
import ToolNav from "../../share/components/tool-nav";
import "./Tools.scss";
import SEC1 from "./Assests/BackLink/sec1.png";
import SEC2 from "./Assests/BackLink/sec2.png";
import SEC3 from "./Assests/Rank/sec3.png";
import SEC4 from "./Assests/BackLink/sec3.png";
import NEWSEC from "./Assests/BackLink/newsec1.png";
import NEWSEC2 from "./Assests/BackLink/newsec2.png";
import URLImg from "./Assests/BackLink/url.png";

import { FooterTool } from "./Footer/Footer";
import { domainRegex, formatNumberWithSymbols } from "../../../helperJs/helper";
import useIpAddress from "../../../helperJs/useIpAddress";

function BacklinkChecker() {
  const [toolSelected, setToolSelected] = useState(0);
  const [Data, setData] = useState([]);
  const navigate = useNavigate();
  const [domain, setDomain] = useState("Domain");
  const [path, setPath] = useState("Backlink Checker");
  const [keyword, setKeyword] = useState("");
  const [domainAuthority, setDomainAuthority] = useState("");
  const [Error, setError] = useState();
  const [loader, setLoader] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(false);
  const ipAddress = useIpAddress();

  const get_backlink_data = (config) =>
    `https://app.rankspro.io/api/user/backlinkdataget/?domain=${config.domain}&include_subdomains=${config.include_subdomains}`;
  const post_backlink_data = (config) =>
    `https://app.rankspro.io/api/user/backlinkdata/?domain=${config.domain}&include_subdomains=${config.include_subdomains}`;
  const get_domainauthority = (domain) =>
    `https://app.rankspro.io/api/user/domainauthorityget/?domain=${domain}`;
  const post_freebacklinkdata = () =>
    `https://app.rankspro.io/api/user/freebacklinkdata/`;
  const email = "";

  const tool = [
    {
      title: "Backlink Checker",
      desc: " Try the free version of Backlink Checker. Get a glimpse into the power of our premium tool.",
      api: "",
      searchOption: true,
      image: backlinkImg,
    },
    {
      title: "Website “Authority” Checker",
      desc: "Check the “authority” of your domain.",
      api: "",
      searchOption: false,
      image: backlinkImg,
    },
    {
      title: "Broken Link Checker",
      desc: "Check your site for broken inbound and outbound links in seconds.",
      api: "",
      searchOption: false,
      image: backlinkImg,
    },
  ];

  const freeBacklinkData = (data) => {
    const allData = data?.data?.[0];
    const history_list = allData?.history_list
      ? allData?.history_list
      : allData?.data?.[0].history_list;

    const config = {
      domain_name: keyword,
      IP: ipAddress,
      backlinks: allData?.total_backlinks || 0,
      ref_domain:
        history_list?.[history_list?.length - 1]?.referring_domains || 0,
    };

    axios({
      method: "post",
      url: post_freebacklinkdata(),
      headers: {},
      data: config,
    });
  };

  const handleUserBacklinkData = (config) => {
    axios.get(get_backlink_data(config)).then((response) => {
      if (response.data?.length > 0) {
        const data = response.data?.[0];
        freeBacklinkData(data);
        setTimeout(() => {
          setData(data);
        }, 1000);
        setAnchorEl(true);
        setLoader(false);
      } else {
        axios
          .post(post_backlink_data(config))
          .then((response) => {
            if (response.data?.length === 0) {
              setLoader(false);
              setData([]);
              setError("Sorry, No Data Found For This Domain.");
            } else {
              freeBacklinkData(response.data[0]);
              setTimeout(() => {
                setData(response.data[0]);
              }, 1000);
              setAnchorEl(true);
              setLoader(false);
            }
          })
          .catch(() => {
            setLoader(false);
            setData([]);
            setError("Sorry, No Data Found For This Domain.");
          });
      }
      axios.get(get_domainauthority(config.domain)).then((response) => {
        setDomainAuthority(response.data);
      });
    });
  };

  const keywordClickHandler = (e) => {
    e.preventDefault();
    if (keyword === "") {
      setError("Please enter domain");
    } else if (!domainRegex.test(keyword)) {
      setError("Please enter valid domain");
    } else {
      setLoader(true);
      const config = {
        email: email,
        domain: keyword,
        include_subdomains: true,
      };
      handleUserBacklinkData(config);
    }
  };

  const keywordChangeHandler = (target) => {
    setError("");
    if (domain == "URL") {
      setKeyword(target.value);
    } else {
      const url = target.value;
      const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
      setKeyword(match ? match[1].replace(/\s/g, "") : "");
    }
  };

  const domain_data = [{ language: "Domain" }, { language: "URL" }];

  const domainHandler = (e) => {
    if (e.language == "URL") {
      setKeyword(keyword);
    } else {
      const match = keyword.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
      setKeyword(match ? match[1].replace(/\s/g, "") : "");
    }
    setDomain(e.language);
  };

  const Sppiner = () => {
    return (
      <Box
        sx={{ display: "flex", minHeight: 350, minWidth: 350 }}
        className="w-100 h-100 cad"
      >
        <div
          className="spinner-border"
          role="status"
          style={{ color: "#365486", width: "3rem", height: "3rem" }}
        >
          <span className="sr-only"></span>
        </div>
      </Box>
    );
  };

  function handleClose() {
    setAnchorEl(false);
    setData([]);
    setKeyword("");
  }

  const allData = Data?.data?.[0];
  const history_list = allData?.history_list
    ? allData?.history_list
    : allData?.data?.[0].history_list;

  const currentPageTableData = useMemo(() => {
    const tableData = Data?.data?.[0]?.data || [];
    const array = tableData?.slice(0, 100);
    const sortedData = [...array].sort(
      (a, b) => b.domain_authority - a.domain_authority
    );
    return sortedData;
  }, [Data]);

  function kFormatter(num) {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "K"
      : Math.sign(num) * Math.abs(num);
  }

  const pathChangeHandler = (e) => {
    setPath(e.language);
    navigate(e.path);
  };
  const Section1Ul = [
    "Domain authority (DA) ",
    "Number of referring domains",
    "Number of backlinks",
    "Domain ratings (DR) of the source pages ",
    "Targeted pages with URLs ",
    "Anchor texts distribution ",
  ];
  const Section2Ul = [
    "Perform a backlink audit with ease",
    "Analyze your competitors’ backlink profiles and uncover their backlink strategies",
    "Analyze anchor texts in a backlink profile and build sound SEO strategy",
    "Discover the DoFollow Vs. NoFollow link rate",
  ];
  return (
    <div style={{ overflow: "auto", height: "100vh" }}>
      <div className="backlinks-checker-container">
        <ToolNav />
        <div className="Tool-App">
          <div className="backlinks-container">
            <div>
              {/* <h4 className="heading-medium font-regular">Free SEO Tools /</h4> */}
              <h1 className="heading-xlarge font-bold">
                {tool[toolSelected]?.title}
              </h1>
              <p className="heading-medium font-regular">
                {tool[toolSelected]?.desc}
              </p>
              {/* <div>
        <ActiveLastBreadcrumb
          selectTool={setToolSelected}
          activeTool={toolSelected}
        />
      </div> */}
              {tool[toolSelected]?.searchOption ? (
                <div className="search-container">
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <form onSubmit={(e) => keywordClickHandler(e)}>
                        <input
                          type="text"
                          className="input-search"
                          placeholder="Enter domain name"
                          value={keyword}
                          style={{ height: "50px" }}
                          onChange={(e) => keywordChangeHandler(e.target)}
                        />
                        {Error && (
                          <span className="msg-error heading-xs font-regular">
                            {Error}
                          </span>
                        )}
                      </form>
                    </Grid>
                    <Grid item xs={4}>
                      <Dropdown
                        title={domain}
                        callback={domainHandler}
                        data={domain_data}
                        style={{
                          width: "100%",
                          height: "50px",
                          textTransform: "none",
                          backgroundColor: "transparent",
                          boxShadow: "none",
                          borderRadius: "5px",
                          border: "1px solid #0000004D",
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    variant="outlined"
                    className="btn-backlink"
                    onClick={(e) => keywordClickHandler(e)}
                  >
                    Submit
                  </Button>
                </div>
              ) : (
                <div style={{ width: "60%" }} className="search-container">
                  <p className="heading-xs font-bold">coming soon...</p>
                </div>
              )}
            </div>
            <img
              src={backlinkImg}
              alt=""
              className="backlink-img flex-none-sm"
            />
          </div>
        </div>

        <PopOver anchorEl={anchorEl} setAnchorEl={() => setAnchorEl(false)}>
          <Box
            sx={{
              bgcolor: "rgba(255, 255, 255, 1)",
              minWidth: { md: 700 },
            }}
            className=""
          >
            {Data?.length === 0 ? (
              <Sppiner />
            ) : (
              <Box sx={{ width: "100%", cursor: "default" }}>
                <div className="w-100 px-4 pt-2">
                  <Typography
                    component="h1"
                    id="select-google-property"
                    className="heading-large font-bold popover-list-header py-2 px-2"
                  >
                    Backlink Profile For :{" "}
                    <span style={{ color: "#e95655" }}>{keyword}</span>
                    <ToolTip
                      title={`Backlink data search for ${keyword} domian`}
                    />
                    <IconButton
                      className="popover-close-icon"
                      onClick={handleClose}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(240, 242, 255, 1)",
                        },
                      }}
                    >
                      <CloseIcon sx={{ color: "black" }} fontSize="large" />
                    </IconButton>
                  </Typography>
                  <div className="row mb-2 px-2">
                    <div className="col-12 col-md-4">
                      <div className="d-flex align-items-center">
                        <Box className="d-flex">
                          {/* <CircularProgress
                        variant="determinate"
                        value={domainAuthority || 100}
                      /> */}
                        </Box>
                        <span className="heading-medium font-regular me-2 text-nowrap">
                          DOMAIN AUTHORITY :{" "}
                        </span>
                        <span
                          className="heading-xlarge font-bold"
                          style={{ color: "#e95655" }}
                        >
                          {domainAuthority || 0}
                        </span>
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <div className="d-flex align-items-center">
                        <span className="heading-medium font-regular me-2 text-nowrap">
                          REFERRING DOMAINS :{" "}
                        </span>
                        <span
                          className="heading-xlarge font-bold"
                          style={{ color: "#e95655" }}
                        >
                          {formatNumberWithSymbols(
                            history_list?.[history_list?.length - 1]
                              ?.referring_domains
                          ) || 0}
                        </span>
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <div className="d-flex align-items-center">
                        <span className="heading-medium font-regular me-2 text-nowrap">
                          BACKLINKS :{" "}
                        </span>
                        <span
                          className="heading-xlarge font-bold"
                          style={{ color: "#e95655" }}
                        >
                          {formatNumberWithSymbols(allData?.total_backlinks) ||
                            0}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      overflow: "scroll",
                      maxHeight: "420px",
                      border: "1px solid gray",
                    }}
                    className="mb-2"
                  >
                    <table className="table backlink-list-table mt-0">
                      <thead>
                        <tr>
                          <th scope="col" className="">
                            DR
                            <ToolTip title="Domain Rank: A metric that denotes the domain rank, referring to the target page or domain, calculated by summing each page’s rank value, narrowed down to a range on the scale. 25-35 range means new domain with limited backlinks, 200-300 range means older domains with higher quality backlinks, 500+ scale means huge domains with significant authority backlinks." />
                          </th>
                          <th scope="col">
                            Source page title & url | target page
                            <ToolTip
                              title="SEO Title / URL - The title that shows up in
                          a Google search for any given URL, followed
                          by the page URL itself."
                            />
                          </th>
                          <th scope="col" className="">
                            anchor text
                            <ToolTip
                              title="  Anchor Text - The Anchor text is the
                                  visible, clickable text in a hyperlink."
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentPageTableData?.length === 0 ? (
                          <tr>
                            <td className="text-center" colSpan={3}>
                              "No Data found"
                            </td>
                          </tr>
                        ) : (
                          currentPageTableData &&
                          currentPageTableData?.map((item, index) => {
                            return (
                              <tr
                                key={`blacklink-table-list-${index}-${item?.page_from_title}`}
                              >
                                <td className="table-cell-value vert-alg ">
                                  <span className="table-cell-value ">
                                    {item?.domain_authority / 10 < 5
                                      ? 0
                                      : item?.domain_authority / 10 || 0}
                                  </span>
                                </td>
                                <td className="t_left table_cell">
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      height: "65px",
                                    }}
                                    className="ellipsis"
                                  >
                                    <span className="mt-0 blacklink-table-span">
                                      <a
                                        href={item?.url_from}
                                        className=""
                                        target="_blank"
                                        style={{
                                          color: "#475EE5",
                                          paddingLeft: "0px",
                                        }}
                                        rel="noopener noreferrer"
                                      >
                                        {item?.page_from_title}
                                      </a>
                                    </span>
                                    <span className="mt-0 blacklink-table-span">
                                      <b>Source:</b>
                                      <a
                                        href={item?.url_from}
                                        target="_blank"
                                        className=""
                                        rel="noopener noreferrer"
                                      >
                                        {item?.url_from}
                                        <OpenInNewIcon
                                          sx={{
                                            fontSize: "13px",
                                            marginLeft: "6px",
                                          }}
                                        />
                                      </a>
                                    </span>
                                    <span className="mt-0 blacklink-table-span ">
                                      <b>Target:</b>
                                      <a
                                        href={item?.url_to}
                                        target="_blank"
                                        className=""
                                        rel="noopener noreferrer"
                                      >
                                        {item?.url_to}
                                        <OpenInNewIcon
                                          sx={{
                                            fontSize: "13px",
                                            marginLeft: "6px",
                                          }}
                                        />
                                      </a>
                                    </span>
                                  </div>
                                </td>
                                <td className="table_cell vert-alg ">
                                  <span className="table-cell-value ">
                                    {item?.anchor}
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  className="row p-3"
                  style={{
                    backgroundColor: "#FFE6BF",
                  }}
                >
                  <div className="col-8">
                    <div>
                      <h1 className="heading-medium font-bold mb-1">
                        {`Want to see all ${
                          kFormatter(allData?.total_backlinks) || 0
                        } backlinks?`}
                      </h1>
                      <p className="heading-small font-regular m-0">
                        Sign up for RanksPro.io to check backlink profile of any
                        website or URL.
                      </p>
                    </div>
                  </div>
                  <div className="col-4 p-sm-0 d-flex align-items-center justify-content-center">
                    <a target="blank" href="/register">
                      <CustomButtonStyle
                        name="Start 7-Day Free Trial"
                        hover="#365486"
                        bgColor="#365486"
                        variant="contained"
                        className="font-regular heading-small"
                      />
                    </a>
                  </div>
                </div>
              </Box>
            )}
          </Box>
        </PopOver>
        <ReCaptcha />
      </div>
      {/* Body Start */}
      <div className="BackLinkBody">
        <div className="BackBox">
          <div className="imgBox-style">
            <h5>Free Backlink Checker by RanksPro </h5>
            <p>
              Get real-time backlink data for any website with our free backlink
              checker and analyze the link profiles.{" "}
            </p>
            <div className="IMGbox">
              <img src={SEC4} alt="secOne " />
              <p>
                <b>For example:</b> rankspro.io, esearchlogix.com{" "}
              </p>
            </div>
          </div>
          <div className="imgBox-style">
            <h5>Fastest and Most Accurate Backlink Checker</h5>
            <p>
              Access comprehensive backlink data with RanksPro’s backlink
              checker and evaluate your performance. You can use this tool to
              analyze your website as well as your competitors’ backlink
              profiles. Our database is constantly updating to show you the
              latest data in a matter of seconds.
            </p>
            <div className="IMGbox">
              <img src={SEC1} alt="secOne " />
            </div>
            <h5>Two Simple Ways to Use RanksPro’s Free Backlink Checker</h5>
          </div>
          <h6>By Target Domain </h6>
          <p>
            Just enter the domain address of the website for which you need to
            analyze backlinks and get a list of inbound links. For example:
            rankspro.io, esearchlogix.com, etc.{" "}
          </p>
          <div className="IMGbox">
            <img src={NEWSEC} alt="secOne " />
          </div>
          <h6>By Target URL </h6>
          <p>
            If you want to analyze backlinks for a specific page or content,
            enter its URL and get the desired list of backlinks along with the
            source websites and their links. For instance:
            https://www.rankspro.io/rank-tracking.{" "}
          </p>
          <div className="IMGbox">
            <img src={URLImg} alt="secOne " />
          </div>
          <h5>Track Critical Metrics with Free Backlink Checker </h5>
          <p>
            With RanksPro’s free backlink checker, users get to analyze much
            more than just links. Here are the metrics and other insights the
            tool offers:{" "}
          </p>
          <ul className="ms-4 mt-4 ">
            {Section1Ul?.map((Li) => (
              <li key={Li}>{Li}</li>
            ))}
          </ul>
          <div className="IMGbox">
            {" "}
            <img src={NEWSEC2} alt="secOne " />
          </div>
          <h5 className="text-center">
            Tasks You Can Do Easily with Our Free Backlink Checker{" "}
          </h5>
          <h6>Track Any Website’s Backlinks </h6>
          <p>
            Simply enter a URL to dig up the entire backlink dataset of any
            site. The tool ranks the number of backlinks and referring domains,
            top linking pages, and source authority scores. Therefore, it
            provides a clear view of who links to a domain and how powerful
            those links are.
          </p>
          <h6>Analyze Anchor Texts Distribution </h6>
          <p>
            This tool of RanksPro splits anchor text distribution, enabling you
            to identify which keywords are too optimized, generic links, branded
            anchors, etc. This encourages you to ensure that your backlink
            profile looks natural enough for the search engines, which is
            required to avoid penalties by Google and gain trust and authority
            for your site.{" "}
          </p>
          <h6>Find Competitors’ Backlinks for Free </h6>
          <p>
            Check RanksPro to spy on competitors' backlinking tactics with this
            free backlink checker. Instantly view where their backlinks are
            coming from, which pages are getting the most link equity, and how
            much weightage these sources have. These insights will help in
            optimizing link-building opportunities.{" "}
          </p>
          <h5 className="text-center">
            Benefits of Using a Free Backlink Checker Like RanksPro{" "}
          </h5>
          <p>
            Backlinks are still one of the highly potent ranking factors for
            SEO, but following and analyzing them can easily prove to be
            overwhelming without the right tools. This is where RanksPro comes
            in with its Free Backlink Checker.{" "}
          </p>
          <h6>Instant Access to Valuable Link Insights </h6>
          <p>
            With RanksPro, you can instantly view backlink data for any domain
            without paying a cent. Whether you’re a website owner, digital
            marketer, or SEO consultant, you get immediate access to referring
            domains, total backlinks, top linking pages, and authority metrics.
            It’s a fast and efficient way to evaluate your link-building efforts
            or spy on competitors’ strategies.{" "}
          </p>
          <h6>No Learning Curve – Easy for Everyone </h6>
          <p>
            After signing up for RanksPro, anyone will be able to instantly
            retrieve backlink data for any domain free of cost. This allows
            website owners, digital marketers, and SEO consultants to analyze
            relevant domains, total backlinks, top linking pages, and authority
            metrics instantaneously to quickly and efficiently assess
            link-building practices or spy on the competition.{" "}
          </p>
          <h6>Spot SEO Issues </h6>
          <p>
            Toxic backlinks and unnatural anchor text distribution quietly
            damage your rankings. With RanksPro, you can detect such issues at
            an early stage, keeping your backlink profile healthy. Identify
            spammy or non-relevant links, and take timely action such as
            disavowing harmful domains or cleaning up over-optimized anchor
            usage.{" "}
          </p>
          <h6>Identify New Backlink Opportunities </h6>
          <p>
            Backlink analysis is one of the most important ways to monitor your
            rivals and adapt to their proven strategies. RanksPro allows you to
            find out where your leading competitors acquire their backlinks.
            Find only industry-related websites, blogs, and directories that are
            linking to others in your niche-and target them with confidence.{" "}
          </p>
          <div>
            <h5 className="text-center">
              Some Important Questions About Backlink Analysis{" "}
            </h5>
          </div>
          <h6>How many types of backlinks are there? </h6>
          <p>Essentially, backlinks are of two types: </p>
          <ul>
            <li>
              <b>Dofollow Backlinks:</b> Such links pass link equity (SEO value)
              to upturning search rankings.{" "}
            </li>
            <li>
              <b>Nofollow Backlinks:</b> Though not passing link equity, they
              still offer value in terms of traffic and brand visibility.
            </li>
          </ul>
          <p>
            Some other types of backlinks include social media links, guest post
            links, forum links, editorial links, and directory links. A natural
            mix of these kinds of backlinks gives rise to a healthy SEO
            strategy.{" "}
          </p>
          <h6>Which backlinks are good and which aren’t? </h6>
          <p>
            Well-established backlinks are coming from websites that have a high
            reputation, are relevant, and trustworthy. These backlinks are made
            using anchor texts naturally. These backlinks signal search engines
            to consider your website a reliable source of information,
            increasing search visibility.
          </p>
          <p>
            Bad backlinks originate from low-quality, spammy, or unrelated
            websites or use manipulative anchor text (for example, stuffing
            words with keywords). They often trigger Google penalties or hurt
            your rankings. All good backlinks should generally be organic,
            earned versus bought, or automated link schemes.
          </p>
          <h6>Why is backlink analysis important for SEO? </h6>
          <p>
            Among the top-ranking factors of Google, backlinks are one of the
            most important. They tell search engines your content is credible
            and valuable. With backlink analysis, you can examine the quality of
            the links pointing to your site, eliminate the bad or spammy links,
            and discover which of your pages are getting the most authority.{" "}
          </p>
          A healthy backlink profile is really good for improving rankings,
          generating referral traffic, and increasing your domain authority.
          <h6>How to analyze backlinks for better SEO performance? </h6>
          <p>
            To analyze backlinks the right way, begin by evaluating total
            backlinks, referring domains, anchor texts, and link authority using
            a backlink checker like Ranks Pro. Check if there is diversity in
            anchor text, with most referring domains having a high authority,
            while linking sites are relevant.{" "}
          </p>
          <p>
            Identify links that are toxic or of low quality, which may
            potentially harm your SEO, and proceed to disavow them. Perform
            analysis of trends over time to help you measure your link-building
            progress and its SEO impact.{" "}
          </p>
          <h6>Why is competitor backlink analysis important? </h6>
          <p>
            When you analyze backlinks from your competitors, you are able to
            tell where they seem to gain authority. Analyze which strategies
            they are deploying to rank higher, and where you could obtain links
            for your site. This will show you potential websites that you could
            competitively target.{" "}
          </p>
          <p>
            The insights users get through competitor backlink analysis will
            also help you to optimize your current backlink profile by
            discovering the trends, monitoring current performance, and
            identifying gaps.{" "}
          </p>
          <h6>How to analyze your competitor’s backlinks? </h6>
          <p>
            To analyze a competitor’s backlink profile, you can use RanksPro's
            Free Backlink Checker. It will give comprehensive insights to see a
            complete list of their backlinks, referring domains, anchor texts,
            and authority scores. Analyze which sources they are using to
            increase traffic, what keywords and anchor texts they are
            incorporating, and how credible these sources are. Use this insight
            to find the relevant sources to create backlinks for your website
            (related to your niche) and enhance your link profile health.{" "}
          </p>
          <h6>How to use backlink data for link building? </h6>
          <p>
            The backlinking study enables users to analyze sources from which
            they are getting traffic, how relevant these sources are, and what
            other opportunities they can utilize for new link-building
            activities. Moreover, this data also points out the content that
            often gets maximum priority to attract high-quality backlinks. Using
            this data, you can create or optimize strategies for guest posting,
            outreach, fixing broken links, and creating more link-worthy content
            pieces.{" "}
          </p>
          <br />
          <hr />
          <div className="secEnd">
            <div className="row">
              <div className="col-md-9 Leftb">
                <h3>
                  Want to see how your backlink profile compares to your
                  competitors'? Sign up for a free backlink check today and see
                  who's beating you to the first page of Google!
                </h3>
              </div>
              <div className="col-md-3 Rightb">
                <a href="https://app.rankspro.io/register" target="_blank">
                  <button className="btnNormal">Sign up for a free</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterTool />
    </div>
  );
}

export default BacklinkChecker;
